var map = {
	"./icon-arrow--down.svg": 491,
	"./icon-arrow--right.svg": 492,
	"./icon-check.svg": 493,
	"./icon-cross.svg": 494,
	"./icon-headset.svg": 495,
	"./icon-loader.svg": 496,
	"./icon-logotype--stroked.svg": 497,
	"./icon-play.svg": 498,
	"./icon-plus.svg": 499,
	"./icon-social--bitcoin.svg": 500,
	"./icon-social--discord.svg": 501,
	"./icon-social--facebook.svg": 502,
	"./icon-social--linkedin.svg": 503,
	"./icon-social--reddit.svg": 504,
	"./icon-social--slack.svg": 505,
	"./icon-social--telegram.svg": 506,
	"./icon-social--twitter.svg": 507,
	"./logotype-outline.svg": 508,
	"./logotype-p.svg": 509,
	"./logotype.svg": 510
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 511;


//////////////////
// WEBPACK FOOTER
// ./src/svg ./~/xml-loader! ^\.\/.*\.svg$
// module id = 511
// module chunks = 0